var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"banner"}),_c('router-view'),(_vm.footerShow)?_c('div',{staticClass:"footer"},[_vm._v("© Keysight Technologies 2000-2019")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }